// YadsCancelScheduleAction.js
import {
  DELETE_YADS_SCHEDULE_REQUEST,
  DELETE_YADS_SCHEDULE_SUCCESS,
  DELETE_YADS_SCHEDULE_FAILURE,
  DELETE_YADS_SCHEDULE_RESET,
} from '../../../Constants/actionTypes';

import { deleteYadsScheduleIngestion } from '../../../Constants/apiService';

export const deleteYadsScheduleRequest = () => ({ type: DELETE_YADS_SCHEDULE_REQUEST });
export const deleteYadsScheduleSuccess = (data) => ({ type: DELETE_YADS_SCHEDULE_SUCCESS, payload: data });
export const deleteYadsScheduleFailure = (err) => ({ type: DELETE_YADS_SCHEDULE_FAILURE, payload: err });
export const deleteYadsScheduleReset   = () => ({ type: DELETE_YADS_SCHEDULE_RESET });

export const cancelYadsScheduledIngestion = (taskId, tenantPayload) => {
  return async (dispatch, getState) => {
    dispatch(deleteYadsScheduleRequest());
    const accessToken = getState().auth.accessToken;

    try {
      const res = await deleteYadsScheduleIngestion(taskId, tenantPayload, accessToken);
      dispatch(deleteYadsScheduleSuccess(res));
    } catch (error) {
      const msg = error.message?.includes("fetch")
        ? "Unable to cancel schedule. Please try again."
        : error.message;
      dispatch(deleteYadsScheduleFailure(msg));
    }
  };
};
